import { Cart } from '@fhs-legacy/frontend/src/pages/cart/cart';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function CartPage() {
  return <Cart />;
}
